import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface SetShowMetricsBannerParams {
  showMetricsBanner: boolean;
}

export class SetShowMetricsBannerRequest extends Request<SetShowMetricsBannerParams, IResult> {
  constructor(params: SetShowMetricsBannerParams) {
    super('setShowMetricsBanner', params);
  }
}
